import classNames from 'classnames'
import { h, JSX } from 'preact'

import { RadioInput } from '../../components/forms/radio-input/radio-input'
import { PaymentGatewayValidationErrors, PaymentOption } from '../../types'

export interface PaymentSectionProps {
    paymentOptions: Array<PaymentOption>
    selectedPaymentGateway: {
        value: string
        onChange: (name: string) => Promise<void>
    }
    title: string
    errors?: PaymentGatewayValidationErrors
}

export const PaymentSection = (props: PaymentSectionProps): JSX.Element => {
    return (
        <div class="checkout__section">
            {props.paymentOptions.length > 1 && (
                <fieldset>
                    <legend class="bold checkout__section-title">{props.title}</legend>
                    <div>
                        {props.paymentOptions.map((paymentOption: PaymentOption, index: number) => (
                            <RadioInput
                                key={index}
                                name="paymentOption"
                                id={paymentOption.name}
                                onClick={() => {
                                    void props.selectedPaymentGateway.onChange(paymentOption.name)
                                }}
                                isChecked={
                                    props.selectedPaymentGateway.value === paymentOption.name
                                }
                                label={paymentOption.label}
                            />
                        ))}
                    </div>
                </fieldset>
            )}
            {props.paymentOptions
                .filter((x) => x.debug && x.name === props.selectedPaymentGateway.value)
                .map((paymentOption) => (
                    <div
                        class={classNames('checkout__debug')}
                        key={paymentOption.name}
                        dangerouslySetInnerHTML={{ __html: paymentOption.debug || '' }}
                    />
                ))}
            {props.errors && (
                <ul class="checkout__section-error checkout__section-error--bottom">
                    {Object.entries(props.errors).map(([key, value]) => (
                        <li key={key}>{value}</li>
                    ))}
                </ul>
            )}
        </div>
    )
}
